import { Injectable, signal } from '@angular/core';

import { CoverageDevice } from '@shure/shared/angular/features/device-coverage/data-access';

import { OnboardingStep, OnboardingAction } from '../models';

@Injectable({
	providedIn: 'root'
})
export class Coverage3DOnboardingService {
	private readonly onboardingDevice = signal<CoverageDevice | undefined>(undefined);

	public readonly $onboardingDevice = this.onboardingDevice.asReadonly();

	public readonly onboardingAction = signal<OnboardingAction | undefined>(undefined);

	public readonly activeStep = signal<OnboardingStep | undefined>(undefined);

	public setOnboardingDevice(device: CoverageDevice | undefined): void {
		this.onboardingDevice.set(device);
	}

	public resetOnboardingState(): void {
		this.onboardingDevice.set(undefined);
		this.onboardingAction.set(undefined);
		this.activeStep.set(undefined);
	}
}
